export const APP_LOGIN_URL = 'https://app.fisfleetgo.com';
